var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "inline" } }, [
    _c("div", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row flex-center-space-between" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.produitLocal.designation,
                  expression: "produitLocal.designation",
                  modifiers: { trim: true }
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    content: "Désignation générique du produit",
                    placement: "top"
                  },
                  expression:
                    "{ content: 'Désignation générique du produit', placement: 'top' }"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                disabled: _vm.produit && _vm.produit.typeProduit === "Produit",
                type: "text",
                placeholder: "Désignation",
                required: "",
                title: "Désignation de votre produit"
              },
              domProps: { value: _vm.produitLocal.designation },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.produitLocal,
                    "designation",
                    $event.target.value.trim()
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            !_vm.$v.produitLocal.designation.required
              ? _c("div", { staticClass: "error" }, [
                  _vm._v("Ce champ est requis")
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "col-3 flex-end" },
            [
              _c("span", [_vm._v("Grammage")]),
              _c("InputNumber", {
                staticClass: "ml-1 mr-1",
                staticStyle: { width: "100px" },
                attrs: {
                  disabled:
                    _vm.produit && _vm.produit.typeProduit === "Produit",
                  typeFiltre: "quantite"
                },
                model: {
                  value: _vm.produitLocal.grammage,
                  callback: function($$v) {
                    _vm.$set(_vm.produitLocal, "grammage", $$v)
                  },
                  expression: "produitLocal.grammage"
                }
              }),
              _vm._v("g "),
              !_vm.$v.produitLocal.grammage.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "col-3 flex-end" }, [
            _c("span", [_vm._v("Coté en ")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.produitLocal.uc,
                  expression: "produitLocal.uc"
                }
              ],
              staticClass: "ml-1",
              staticStyle: { width: "100px" },
              attrs: {
                disabled: _vm.produit && _vm.produit.typeProduit === "Produit",
                type: "text",
                list: "texteUC"
              },
              domProps: { value: _vm.produitLocal.uc },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.produitLocal, "uc", $event.target.value)
                }
              }
            }),
            _vm._m(0),
            !_vm.$v.produitLocal.uc.required
              ? _c("div", { staticClass: "error" }, [
                  _vm._v("Ce champ est requis")
                ])
              : _vm._e()
          ])
        ])
      ]),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row push-top-1rem" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("div", { staticClass: "push-right-2rem" }, [
                _vm._v("Ingrédient")
              ]),
              _c("div", { staticClass: "bg-gradient-bleu text-white" }, [
                _vm._v(_vm._s(_vm.nomIngredient(_vm.produitLocal.ingredientId)))
              ]),
              !_vm.produit || _vm.produit.typeProduit !== "Produit"
                ? _c("RechercheIngredients", {
                    attrs: {
                      liste: _vm.ingredients,
                      placeHolder: "Rechercher un ingrédient...",
                      cacherAuto: true,
                      small: true
                    },
                    on: {
                      "selection-ingredient": function($event) {
                        return _vm.setItemIngredientId($event)
                      }
                    }
                  })
                : _vm._e(),
              !_vm.$v.produitLocal.ingredientId.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "col-6" }, [
            _c("span", [_vm._v("Unité de production par défaut")]),
            _c("div", { staticClass: "bg-gradient-bleu text-white pl-2" }, [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.upIngredient(_vm.produitLocal.ingredientId)
                  )
                }
              })
            ])
          ])
        ]),
        !_vm.produit || _vm.produit.typeProduit !== "Produit"
          ? _c("div", { staticClass: "row flex-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn bleuAgap",
                  attrs: {
                    disabled:
                      !_vm.produitEstModifie ||
                      !_vm.$v.produitLocal.designation.required ||
                      !_vm.$v.produitLocal.ingredientId.required ||
                      !_vm.$v.produitLocal.grammage.required ||
                      !_vm.$v.produitLocal.uc.required
                  },
                  on: {
                    click: function($event) {
                      return _vm.enregistrer()
                    }
                  }
                },
                [_vm._v("Enregistrer")]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("datalist", { attrs: { id: "texteUC" } }, [
      _c("option", { attrs: { value: "Kg" } }),
      _c("option", { attrs: { value: "Litre" } }),
      _c("option", { attrs: { value: "Carton" } }),
      _c("option", { attrs: { value: "Unité" } }),
      _c("option", { attrs: { value: "Pièce" } }),
      _c("option", { attrs: { value: "Seau" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }